import { ALLOCATIONS, EXPERIMENTS, ROLLOUTS } from '@fiverr-private/listing_experiments';

// The rollout is re-checked here, not just at allocation time, so setting it to 0% turns the modal
// off for users who were already allocated.
export const shouldShowFiltersModal = (
    isBusiness: boolean,
    isTouch: boolean,
    abTests: Record<string, number>,
    rollouts: Record<string, boolean>
) =>
    !isBusiness &&
    !isTouch &&
    !!rollouts[ROLLOUTS.CROWS_FILTERS_MODAL] &&
    Number(abTests[EXPERIMENTS.CROWS_FILTERS_MODAL]) > Number(ALLOCATIONS.CONTROL);
